import {
  getApiV1ThreeLetterCodePartnerAdminsContractPlans,
  getGetApiV1ThreeLetterCodePartnerAdminsContractPlansKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsContractPlans200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** パートナーの 3 文字コード */
  threeLetterCode: string;
};

type ReturnType = {
  /** 契約プラン一覧データ */
  data: GetApiV1ThreeLetterCodePartnerAdminsContractPlans200;
};

type IUseGetPartnerAdminsContractPlanList = (args: Args) => ReturnType;

/**
 * 企業契約期間 編集フォーム向け契約プラン一覧取得フック
 *
 * - フォームの選択肢として使用するため絞り込みなし・全件取得
 * - 廃止済みプランのフィルタリングは converter（convertToContractPlanOptions）側で行う
 */
export const useGetPartnerAdminsContractPlanList: IUseGetPartnerAdminsContractPlanList = ({
  threeLetterCode,
}) => {
  const { data } = useFetch<GetApiV1ThreeLetterCodePartnerAdminsContractPlans200>(
    getGetApiV1ThreeLetterCodePartnerAdminsContractPlansKey(threeLetterCode),
    () => getApiV1ThreeLetterCodePartnerAdminsContractPlans(threeLetterCode),
    { suspense: true }
  );

  return { data };
};
